import React, { memo as Memo, useMemo, useRef, useState } from 'react'
//* Components
import { Icon, ButtonCreateDebateBig, Container, DebateWindow } from 'components/common'

//* Style
import DebateSliderStyle from './style'

//* Splide slider
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';

const DebateSlider = Memo(({ debates }) => {
    const slider = useRef()

    const [progressPercent, setProgressPercent] = useState(0)

    const storeDebates = useMemo(() => {
        return debates?.map(i => (
            <SplideSlide key={i.id}>
                <DebateWindow debate={i} />
            </SplideSlide>
        ))
    }, [debates])

    return (
        <DebateSliderStyle>
            <Container>
                <Splide
                    ref={slider}
                    onMove={() => { setProgressPercent(100 * slider.current?.splide.index / slider.current?.splide.Components.Controller.getEnd()) }}
                    renderControls={() => (
                        <div className="splide__arrows">
                            <button className="splide__arrow splide__arrow--prev"><Icon className='op-arrowLeft' /></button>
                            <button className="splide__arrow splide__arrow--next"><Icon className='op-arrowLeft' /></button>
                        </div>
                    )}
                    options={{
                        type: 'slide',
                        autoWidth: true,
                        gap: 24,
                        pagination: false
                    }}
                >
                    <SplideSlide>
                        <ButtonCreateDebateBig content={'Create Debate'} />
                    </SplideSlide>
                    {storeDebates}
                </Splide>
                <div className="my-slider-progress">
                    <div style={{ width: `${progressPercent}%` }} className="my-slider-progress-bar"></div>
                </div>
            </Container>
        </DebateSliderStyle>
    )
})

export default DebateSlider